import React from 'react'
import {
  IconAppleColored,
  IconFacebookColored,
  IconGoogleColored,
} from 'src/viewLayer/components/DesignSystem'

export default (icon) => {
  switch (icon) {
    case 'apple':
      return <IconAppleColored />
    case 'facebook':
      return <IconFacebookColored />
    case 'google':
      return <IconGoogleColored />
    default:
      return null
  }
}
